import { httpClient } from "@/services";
import { driverStatementsHeader } from "@/constants/defaultHeader";
import requestKeys from "@/constants/requestKeys";

export default {
	state: {
		driverStatementsData: null,
		driverStatementsList: [],
		driverStatementsFilterList: null,
		tripsTableActiveList: [],
		tripsTableList: [],
		fuelTableActiveList: [],
		fuelTableList: [],
		additionalPaymentsTableList: [],
		additionalPaymentsTableActiveList: [],
		schedulePaymentsTableList: [],
		schedulePaymentsTableActiveList: [],
		driverStatementsPreloader: false
	},
	mutations: {
		updateItem(state, row) {
			const idx = state.driverStatementsList.findIndex(item => item.id === row.id);
			state.driverStatementsList.splice(idx, 1, row);
		},
		updateListAfterRemoveAdditionalPayments(state, id) {
			const idx = state.additionalPaymentsTableList.findIndex(item => item.id === id);
			if (idx !== -1) state.additionalPaymentsTableList.splice(idx, 1);
		},
		updateDeleteItem(state, id) {
			const idx = state.driverStatementsList.findIndex(item => item.id === id);
			state.driverStatementsList.splice(idx, 1);
		},
		updateDriverStatementsList(state, { drivers, filter }) {
			state.driverStatementsList = drivers;
			state.driverStatementsFilterList = filter;
		},
		updateAddItem(state, { key, item, nameComponent }) {
			const id = item['trip_id'] || item['fuel_id'];
			const stateKey = key === 'plus' ? `${ nameComponent }TableList` : `${ nameComponent }TableActiveList`;
			const pushedKey = key !== 'plus' ? `${ nameComponent }TableList` : `${ nameComponent }TableActiveList`;
			const idx = state[stateKey].findIndex(body => {
				const bodyId = body['trip_id'] || body['fuel_id'];
				return bodyId === id;
			});
			state[stateKey].splice(idx, 1);
			state[pushedKey].push(item);
		},
		updateHandlerTable(state, { key, nameComponent }) {
			if (key === 'plus') {
				state[`${ nameComponent }TableActiveList`] = [ ...state[`${ nameComponent }TableActiveList`], ...state[`${ nameComponent }TableList`] ];
				state[`${ nameComponent }TableList`] = [];
			} else {
				state[`${ nameComponent }TableList`] = [ ...state[`${ nameComponent }TableList`], ...state[`${ nameComponent }TableActiveList`] ];
				state[`${ nameComponent }TableActiveList`] = [];
			}
		},
		/* eslint-disable-next-line */
		updateEditDriverStatements(state, {
			trips_selected = [],
			trips = [],
			statement,
			fuel = [],
			fuel_selected = [],
			addition = [],
			addition_selected = [],
			category = [],
			scheduled_payments = [],
			scheduled_payments_selected = []

		}) {
			state.driverStatementsData = statement;
			state.tripsTableList = trips;
			state.tripsTableActiveList = trips_selected;
			state.fuelTableList = fuel;
			state.fuelTableActiveList = fuel_selected;
			state.additionalPaymentsTableActiveList = addition_selected;
			state.additionalPaymentsTableList = addition;
			state.additionalPaymentsCategoryList = category;
			state.schedulePaymentsTableList = scheduled_payments;
			state.schedulePaymentsTableActiveList = scheduled_payments_selected;
		},
		updateAddition(state, { row, id }) {
			if (id) {
				const idx = state.additionalPaymentsTableList.findIndex(item => item.id === id);
				state.additionalPaymentsTableList.splice(idx, 1, row);
			} else {
				state.additionalPaymentsTableList.push(row);
			}
		}
	},
	actions: {
		async onAddition({ commit }, { values, id }) {
			const uri = id ? `/drivers-statements/updateAddition/${ id }` : '/drivers-statements/setAddition';
			try {
				const { data } = await httpClient.post(uri, values);
				if (data && data.status) {
					commit('updateAddition', { row: data.row, id });
					return data;
				}
			} catch (e) {
				console.error(e);
			}
		},
		async onDriverStatementsSetPay({ commit, dispatch }, { id, ...obj }) {
			try {
				const { data } = await httpClient.post(`/drivers-statements/setPay/${ id }`, obj);
				const { status, row } = data;
				if (status) {
					commit('updateItem', row);
					dispatch("setAlert", { type: "success", message: "Save Successfully" });
				} else {
					dispatch("setAlert", { type: "error", message: "Saving error" });
				}
			} catch (e) {
				console.error(e);
			}
		},
		async onEditDriverStatements({ commit, dispatch }, id) {
			try {
				dispatch("actionPreloader", true);
				const { data } = await httpClient.get(`/drivers-statements/${ id }/edit`);
				if (data) {
					commit('updateEditDriverStatements', data);
				}
				dispatch("actionPreloader", false);
			} catch (e) {
				console.error(e);
			}
		},
		async getDriverStatementsMails({ dispatch }, rows) {
			try {
				const { data } = await httpClient.post('/drivers-statements/getEmail', { rows: rows });
				if (data && data.status) {
					return data;
				}
				dispatch("setAlert", { type: "error", message: "Saving error" });

			} catch (e) {
				console.error(e);
			}
		},
		async onDriverStatementsSend({ dispatch }, rows) {
			try {
				const { data } = await httpClient.post('/drivers-statements/send', { rows: rows });
				if (data && data.status) {
					return data;
				}
				dispatch("setAlert", { type: "error", message: "Saving error" });

			} catch (e) {
				console.error(e);
			}
		},
		async getDriverStatementsList({ commit, dispatch }) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.get('/drivers-statements');
				if (data) {
					commit('updateDriverStatementsList', data);
					commit('updateSettings', { settings: data.settings, key: requestKeys.DRIVER_STATEMENTS, defaultHeader: driverStatementsHeader });
				}
				dispatch("actionPreloader", false);
			} catch (e) {
				console.error(e);
			}
		},
		async onDriverStatementsCreate(ctx, values) {
			let response = null;
			try {
				if (values) {
					response = await httpClient.post('/drivers-statements/create', values);
				} else {
					response = await httpClient.get('/drivers-statements/create');
				}

				const { data } = response;
				if (data && !data.status) {
					return data;
				}
			} catch (e) {
				console.error(e);
			}
		},
		async onDriverStatementsSave({ dispatch }, values) {
			try {
				const { data } = await httpClient.post('/drivers-statements', values);

				if (data) {
					dispatch('getDriverStatementsList');
					return data;
				}
			} catch (e) {
				console.error(e);
			}
		},
		async onDriverStatementsEdit({ dispatch, commit }, values) {
			const { id, ...obj } = values;
			try {
				const { data } = await httpClient.put(`/drivers-statements/${ id }`, obj);

				if (data) {
					const { status, row } = data;
					if (status) {
						commit('updateItem', row);
						dispatch("setAlert", { type: "success", message: "Save Successfully" });
					} else {
						dispatch("setAlert", { type: "error", message: "Saving error" });
					}

					return status;
				}
			} catch (e) {
				console.error(e);
			}
		},
		async onRemoveAdditionalPayments({ commit, dispatch }, id) {
			try {
				const { data } = await httpClient.delete(`/drivers-statements-payment/${ id }`);
				if (data && data.status) {
					commit('updateListAfterRemoveAdditionalPayments', id);
					dispatch("setAlert", { type: "success", message: "Item removed successfully" });
				} else {
					dispatch("setAlert", { type: "error", message: "Deleted Error" });
				}
			} catch (e) {
				console.error(e);
			}
		},
		async onDriverStatementsFilter({ commit, dispatch }, values) {
			try {
				dispatch("actionPreloader", true);
				const { data } = await httpClient.post('/drivers-statements/list', values);

				if (data) {
					commit('updateDriverStatementsList', data);
					commit('updateSettings', { settings: data.settings, key: requestKeys.DRIVER_STATEMENTS, defaultHeader: driverStatementsHeader });
				}
				dispatch("actionPreloader", false);
			} catch (e) {
				console.error(e);
			}
		},
		/* eslint-disable-next-line */
		async deleteDriverStatement({ commit, dispatch }, id) {
			try {
				dispatch("actionPreloader", true);
				const { data } = await httpClient.delete(`/drivers-statements/${ id }`);
				if (data) {
					commit('updateDeleteItem', id);
					dispatch("setAlert", { type: "success", message: "Delete success" });
				} else {
					dispatch("setAlert", { type: "error", message: "Delete error" });
				}
				dispatch("actionPreloader", false);

			} catch (e) {
				console.error(e);
			}
		},
		onAddItem({ commit }, values) {
			commit('updateAddItem', values);
		},
		onHandlerTable({ commit }, values) {
			commit('updateHandlerTable', values);
		},
	},
	getters: {
		driverStatementsList: (s) => s.driverStatementsList,
		driverStatementsData: (s) => s.driverStatementsData,
		driverStatementsFilterList: (s) => s.driverStatementsFilterList,
		tripsTableActiveList: (s) => s.tripsTableActiveList,
		tripsTableList: (s) => s.tripsTableList,
		fuelTableActiveList: (s) => s.fuelTableActiveList,
		fuelTableList: (s) => s.fuelTableList,
		schedulePaymentsTableActiveList: (s) => s.schedulePaymentsTableActiveList,
		schedulePaymentsTableList: (s) => s.schedulePaymentsTableList,
		additionalPaymentsTableList: (s) => s.additionalPaymentsTableList,
		additionalPaymentsTableActiveList: (s) => s.additionalPaymentsTableActiveList,
		additionalPaymentsCategoryList: (s) => s.additionalPaymentsCategoryList,
		driverStatementsPreloader: s => s.driverStatementsPreloader
	},
};
